module.exports = __webpack_public_path__ + "static/media/logo-small.35b0a031.svg";